import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SourceOfBusiness } from "../api/models";
import { State } from "../store/interfaces";
import {
  loadSourceOfBusinessErrorAction,
  loadSourceOfBusinessRequestAction,
  loadSourceOfBusinessSuccessAction,
} from "../store/reducers/sourceOfBusiness";
import { StatusCodes } from "http-status-codes";
import { SourceOfBusinessService } from "../api/services";

export const useSourceOfBusiness = (
  sourseOfBusinessService: SourceOfBusinessService
) => {
  const intent = useSelector((state: State) => state.sourceOfBusiness);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadSourceOfBusiness = async () => {
    if (intent.isLoading || intent.isLoaded) {
      return;
    }
    dispatch(loadSourceOfBusinessRequestAction());
    try {
      const response = await sourseOfBusinessService.loadAllSourceOfBusiness();

      return dispatch(loadSourceOfBusinessSuccessAction(response));
    } catch (error) {
      return dispatch(loadSourceOfBusinessErrorAction());
    }
  };

  const createSourceOfBusiness = async (
    data: SourceOfBusiness,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await sourseOfBusinessService.createSourceOfBusiness({
        ...data,
      });
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError("Unable to update details");
      }
    } catch (error) {
      setUpdateError("Unable to update details");
    }
    setUpdating(false);
  };

  const updateSourceOfBusiness = async (
    data: SourceOfBusiness,
    id?: string,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await sourseOfBusinessService.updateSourceOfBusiness(
        {
          ...data,
        },
        id
      );
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError("Unable to update details");
      }
    } catch (error) {
      setUpdateError("Unable to update details");
    }
    setUpdating(false);
  };

  return {
    loadSourceOfBusiness,
    createSourceOfBusiness,
    updateSourceOfBusiness,
    updating,
    updateError,
  };
};
